import { api } from "@/api/api";

export const Download = {
    state: {
        downloadList: [],
        downloadNoticeList: [],
        totalCount: 0,
    },
    getters: {
        getDownloadList(state) {
            return state.downloadList;
        },
        getDownloadTotalCount(state) {
            return state.totalCount;
        },
        getDownloadNoticeList(state) {
            return state.downloadNoticeList;
        }
    },
    mutations: {
        setDownloadList(state, payload) {
            state.downloadList = payload;
        },
        setDownloadTotalCount(state, payload) {
            state.totalCount = payload;
        },
        setDownloadNoticeList(state, payload) {
            state.downloadNoticeList = payload;
        }
    },
    actions: {
        async getDownloadList({ commit }, param) {
            await api.download
                .getDownloadList(param)
                .then((res) => {
                    commit("setDownloadList", res.data.download);
                    commit("setDownloadTotalCount", res.data.total);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getDownloadNoticeList({commit}, param) {
            await api.download
            .getDownloadNoticeList(param)
            .then((res) => {
                console.log(res.data)
                commit("setDownloadNoticeList", res.data.notice);
            })
            .catch((err) => {
                console.log(err);
            });
        return Promise.resolve();
        },
        
        async getDownload(_, id) {
            const response = await api.download
                .getDownload(id)
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve(response.data);
        },

        async getFileDownload(_, file_name) {
            const response = await api.download
                .getFileDownload(file_name)
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve(response);
        },

        async addDownload({ dispatch }, args) {
            await api.download
                .addDownload(args)
                .then(() => {
                    dispatch("getDownloadList");
                })
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve();
        },

        async updateDownload({ dispatch }, args) {
            await api.download
                .updateDownload(args)
                .then(() => {
                    dispatch("getDownloadList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteDownload({ dispatch }, args) {
            await api.download
                .deleteDownload(args)
                .then(() => {
                    dispatch("getDownloadList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },
    },
};
